'use client';
/*
 * Documentation:
 * CTA Card — https://app.subframe.com/6fc7f5fbb098/library?component=CTA+Card_49303866-eb4c-48c1-880b-e18e2b70193e
 */

import React from 'react';
import { FeatherChevronRight } from '@subframe/core';
import * as SubframeUtils from '../utils';

interface CtaCardRootProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'outline' | 'fill';
  leftSlot?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}

const CtaCardRoot = React.forwardRef<HTMLDivElement, CtaCardRootProps>(function CtaCardRoot(
  { variant = 'outline', leftSlot, children, className, ...otherProps }: CtaCardRootProps,
  ref,
) {
  return (
    <div
      className={SubframeUtils.twClassNames(
        'group/49303866 bg-default-background flex cursor-pointer items-center gap-4 rounded-[16px] border border-solid border-neutral-200 px-4 py-4 hover:bg-neutral-50 active:bg-neutral-100',
        {
          'rounded-[16px] border-none bg-neutral-50 shadow-none hover:bg-neutral-100 active:bg-neutral-50':
            variant === 'fill',
        },
        className,
      )}
      ref={ref}
      {...otherProps}
    >
      {leftSlot ? <div className="flex items-start">{leftSlot}</div> : null}
      {children ? (
        <div className="flex shrink-0 grow basis-0 flex-col items-start">{children}</div>
      ) : null}
      <FeatherChevronRight className="text-heading-2 font-heading-2 group-hover/49303866:text-subtext-color text-neutral-400" />
    </div>
  );
});

export const CtaCard = CtaCardRoot;
